import { ReactNode } from 'react'

interface HomeLayoutProps {
  sidebar: ReactNode
  content: ReactNode
}

export default function HomeLayout({ sidebar, content }: HomeLayoutProps) {
  return (
    <div className="flex min-h-screen bg-[#F4F4F5]">
      {/* Left Sidebar - Fixed width */}
      <aside className="w-64 flex-shrink-0 bg-[#F4F4F5]">{sidebar}</aside>

      {/* Right Content - Takes remaining space */}
      <main className="flex-1 overflow-hidden">{content}</main>
    </div>
  )
}
